// @flow
import {LICENSE_ACTION_TYPE} from 'modules/license/constants';
import type {TLicense} from 'modules/license/types';
import {createReducer} from 'modules/redux/reducer';

export type TSetLicenseList = {payload: TLicense[], type: typeof LICENSE_ACTION_TYPE.GET_LICENSE_LIST};
export type TLicenseState = {
    licenseList: TLicense[],
};

export const initialState: TLicenseState = {
    licenseList: [],
};

const reducer = {
    [LICENSE_ACTION_TYPE.GET_LICENSE_LIST]: (state, payload: TLicense[]) => {
        return {
            ...state,
            licenseList: payload,
        };
    },
};

export const licenseReducers = createReducer(initialState, reducer);
